import './bottom-sheet.scss';

import { ReactNode, useEffect } from 'react';

import { useTextColor } from '@/resources/hooks/useTextColor';
import { useWebContext } from '@/resources/hooks/useWebContext';

interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  configColor?: string;
  fontColor?: string;
}

export default function BottomSheet({ open, children, className = '' }: BottomSheetProps) {
  const { setMenuOpen, configs } = useWebContext();
  const textColor = useTextColor(configs.color);

  useEffect(() => {
    setMenuOpen(open);
  }, [open]);

  return (
    <div className={`bottom-sheet-menu ${open ? 'to-top' : 'closed'} ${className}`}>
      <div className="d-flex justify-content-center align-items-center">
        <span className="pull-span" style={{ backgroundColor: textColor }}></span>
      </div>
      {children}
    </div>
  );
}
